import styled from 'styled-components';

const ProductCardStyled = styled.div`
  cursor: pointer;
  position: relative;

  .ProductCard {
  }
`;
const ProductCardContainerStyled = styled.div`
  width: ${(props) => props.width};
  height: ${(props) => props.height};

  .ProductCardContainer {
  }
`;

export { ProductCardContainerStyled, ProductCardStyled as default };
//# sourceMappingURL=bundle.esm3.js.map
